var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { get } from '../../utils/themeGet';
const EyeIcon = (_a) => {
    var { size = 'medium', color = 'inherit' } = _a, rest = __rest(_a, ["size", "color"]);
    const props = Object.assign(Object.assign({}, rest), { color });
    const sizePx = Number.isFinite(size)
        ? size
        : get(`iconSizes.${size}`)(props) || get('iconSizes.medium')(props);
    return (React.createElement("svg", Object.assign({}, props, { width: sizePx, height: sizePx, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M12 4c5.035 0 9.28 3.383 10.586 8-1.307 4.618-5.551 8-10.586 8s-9.28-3.383-10.586-8C2.721 7.382 6.965 4 12 4zm0 2a9.006 9.006 0 00-8.406 5.775L3.511 12l.083.226a9.007 9.007 0 008.13 5.77L12 18a9.006 9.006 0 008.406-5.775l.082-.226-.082-.224a9.007 9.007 0 00-8.13-5.77L12 6zm0 2a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z", fill: "currentColor" })));
};
export default EyeIcon;
